<template>
	<div>
		<app-table
			class="mt-5"
			name="companies"
			:filter-columns="false"
			:class="{ 'is-not-selectable' : isAssigned }"
			:check-all="checkAll"
			:current-page="currentPage"
			:last-page="lastPage"
			:columns="columns"
			:rows="rows"
			:selectable="!isAssigned"
			@on-page="$emit('on-page', $event)"
			@row-is-selected="$emit('row-is-selected', $event)"
			@on-selected-all="$emit('on-selected-all', $event)"
			@on-search-event="$emit('on-search', $event)"
		>
			<template slot="rows" slot-scope="props">
				<td :class="{ 'is-not-selectable' : isAssigned }">
					{{ props.row.name }}
				</td>
				<td>{{ props.row.code }}</td>
			</template>
		</app-table>
	</div>
</template>

<script>

	import appTooltipButton from '@/components/shared/app-tooltip-button';

	function actionsExist() {
		return this.columns.find(c => c.flagVisible);
	}

	function allowEdit({ flagEdit }) {
		return flagEdit ? 'Sí' : 'No';
	}

	function signLabel({ sign }) {
		return sign === 1 ? 'Debe' : 'Haber';
	}

	export default {
		name: 'report-list',
		components: {
			appTooltipButton,
		},
		computed: {
			actionsExist,
		},
		methods: {
			allowEdit,
			signLabel,
		},
		props: {
			checkAll: {
				default: false,
				type: Boolean,
			},
			columns: {
				type: Array,
				required: true,
			},
			currentPage: {
				type: Number,
				default: 1,
			},
			isAssigned: {
				default: false,
				type: Boolean,
			},
			lastPage: {
				type: Number,
				default: 0,
			},
			rows: {
				type: Array,
				required: true,
			},
		},
	};
</script>



// WEBPACK FOOTER //
// src/components/reports-list/report-list.vue